import { motion } from 'framer-motion'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Redirect, Route, useHistory } from 'react-router'
import { RouteI } from 'safe'
import { RootState } from '../redux/store'
import { getRoutes } from '../routes'
import CloseFoodOrder from '../views/Restaurants/CloseFoodOrder'

const RolesPlansGuard = ({
  key,
  exact,
  component: Component,
  setHeaderActions,
  path1,
  path2,
  selected,
  setSelected
}) => {
  const userRole = useSelector((state: RootState) => state.auth.user)

  const [routes, setRoutes] = useState<RouteI[]>([])

  const history = useHistory()

  const variants = {
    enter: ({ direction, animate }) => {
      if (animate)
        return {
          x: direction > 0 ? 1000 : -1000,
          opacity: 0,
        }

      return {}
    },
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1,
    },
    exit: (direction: number) => {
      return {
        zIndex: 0,
        x: direction < 0 ? 1000 : -1000,
        opacity: 0,
      }
    },
  }

  useEffect(() => {
    if (userRole) {
      setRoutes(getRoutes(userRole['custom:user_role'], userRole['custom:user_plan']))
    }
  }, [userRole])

  const renderComponents = (props) => {
    
    let routeIdx : any = routes.findIndex((route) => route.path === path1)
    let pathToRedirect = routes.find((route) => !route.disabled)
    let subPath = pathToRedirect?.subMenu?.find(v => v.path === path2)
    setSelected(routeIdx)
 
    if (routes[routeIdx]?.disabled || subPath?.disabledRole) {

      const subMenus = routes[routeIdx]?.subMenu?.filter(v => !v?.disabledRole)

      if (subMenus && subMenus.length > 0) {
        return (
          <Redirect
          //@ts-ignore
            to={`/dashboard/${pathToRedirect?.path}/${subMenus[0]?.path}`}
          />
        )
      }
   
      return (
        <Redirect
        //@ts-ignore
          to={`/`}
        />
      )
    }
    return <Component setHeaderActions={setHeaderActions} />
  }
  return (
    <motion.div
      // custom={{ direction, animate }}
      variants={variants}
      initial="enter"
      animate="center"
      exit="exit"
      transition={{
        x: {
          type: 'spring',
          stiffness: 300,
          damping: 30,
        },
        opacity: { duration: 0.8 },
      }}
      // onDragEnd={(e, { offset, velocity }) => {
      //   const swipe = swipePower(offset.x, velocity.x)
      //   if (swipe < -swipeConfidenceThreshold) {
      //     paginate(1)
      //   } else if (swipe > swipeConfidenceThreshold) {
      //     paginate(-1)
      //   }
      // }}
    >
      <Route
        key={key}
        path={`/dashboard/${path1}/${path2}`}
        render={(props) => renderComponents(setHeaderActions)}
        exact={exact}
      />

    </motion.div>
  )
}

export default RolesPlansGuard
